<template>
    <!-- <select ref="selectElement" class="form-control kt-selectpicker" /> -->
    <div class="kt-margin-b-20-tablet-and-mobile" :class="[props.size ? props.size : 'col-md-4']">
        <div class="kt-form__group">
            <div class="kt-form__control">
                <select ref="selectElement" class="form-control bootstrap-select">
                    <option
                        v-for="option in enumOptions"
                        :key="option.value"
                        :value="option.value"
                        :selected="isDefaultValue(option.value)"
                    >
                        {{
                            i18n(
                                `${props.enumTranslationNamespace}.${option.name}`,
                                props.enumTranslationParams?.[option.name]
                            )
                        }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
    import { type EnumValueNamePair, Misc } from "@/data/util/Misc";
    import { i18n } from "@/portal/Trans";
    import { type IOptionNameFormatter, Select } from "@/portal/formControls/Select";
    import { onMounted, ref } from "vue";

    const isInitialized = ref<boolean>(false);
    const selectedValue = defineModel<string | undefined>({
        required: true,
    });

    const props = defineProps<{
        dataSource?: IDataSource<any>;
        enumDataSource?: any;
        enumTranslationNamespace?: string;
        // interpolation params per enum option name, e.g. { TwoYearsAgo: { year: 2024 } }
        enumTranslationParams?: Record<string, object>;
        defaultValue?: any;
        size?: string;
        showAllText?: string;
        formatter?: IOptionNameFormatter<any>
    }>();

    const selectElement = ref<HTMLElement | null>(null);
    let select: Select<object>;

    const enumOptions = ref<EnumValueNamePair[]>(
        props.enumDataSource ? Misc.enumsToValueNameArray(props.enumDataSource) : []
    );

    const isDefaultValue = (key: number) => {
        // if (props.multiSelect) return false;
        return props.defaultValue !== undefined && props.defaultValue === key;
    };

    onMounted(() => {
        if (!props.dataSource && !props.enumDataSource)
            throw new Error("No Select data source provided! Please provide either dataSource object or enum!");

        if (props.enumDataSource && !props.enumTranslationNamespace)
            throw new Error("Translation namespace is required! e.g. 'enums.CancellationReason'");

        select = new Select<object>($(selectElement.value!), props.dataSource, props.formatter, false, props.showAllText);

        if (props.dataSource) {
            fetchAndInit();
        } else {
            if (selectedValue.value && select.getOptions().includes(selectedValue.value)) {
                select.setValue(selectedValue.value);
            }
            selectedValue.value = select.getValue();
            select.onChange = () => {
                selectedValue.value = select.getValue();
            };
            isInitialized.value = true;
        }
    });

    function fetchAndInit() {
        select.fetchData(() => {
            select.onChange = () => {
                selectedValue.value = select.getValue();
            };

            if (selectedValue.value && select.getOptions().includes(selectedValue.value)) {
                select.setValue(selectedValue.value);
            }
            isInitialized.value = true;
        });
    }
</script>
